import React, { useState } from "react";
import "./Withdrawl_Request_Form.css";
import Form from "react-bootstrap/Form";
import Pink_Btn from "../../common/common_btn/pink_btn/Pink_Btn";
import Success_Modal from "../../common/common_modal/success_modal/Success_Modal";
import { formatAmount } from "../../../utils/common";
import { useForm } from "react-hook-form";
import { getAllWalletHistory, postAddMoney, postAddWithDraw } from "../../../features/wallet/walletSlice";
import { useDispatch } from "react-redux";
import useRazorpay from "react-razorpay";

const Withdrawl_Request_Form = ({ Wallet }) => {
    const [showModal, setShowModal] = useState(false);
    const {
        register,
        handleSubmit,
        setValue,
        watch, setError,
        formState: { errors },
        reset,
    } = useForm({
        defaultValues: {
            amount: "",
        },
    });
    const amount = watch("amount");

    const quickAmounts = [500, 1000, 2000, 5000];



    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const WithdrawMoneyFuntion = async (data) => {
        setLoading(true);
        try {

            const sendData = new FormData();
            console.log({ AddMoneyFuntion: data });
            sendData.append("amount", data?.amount);
            sendData.append("type", paymentMethod);
            if (paymentMethod == "bank") {

                sendData.append("account_holder_name", data?.account_holder_name);
                sendData.append("account_no", data?.account_no);
                sendData.append("c_account_no", data?.c_account_no);
                sendData.append("ifsc_code", data?.ifsc_code);

            } else if (paymentMethod == "upi") {

                sendData.append("upi_id", data?.upi_id);
                sendData.append("account_holder_name", data?.account_holder_name);

            }

            const res = await dispatch(postAddWithDraw({ data: sendData, }));

            if (res?.meta?.requestStatus === "fulfilled") {
                setShowModal(true);
                reset();
                setTimeout(() => {
                    setShowModal(false);
                }, 3000);
                await dispatch(getAllWalletHistory());
                setValue("payment_method", "bank")
            } else if (res.meta?.requestStatus === "rejected") {
                if (res?.payload.errors?.amount) {
                    setError("amount", {
                        type: "manual",
                        message: res?.payload.errors?.amount,
                    });
                }
            }


        } catch (err) {

            console.error(err);

        } finally {
            setLoading(false);
        }
    }



    const paymentMethod = watch("payment_method");

    return (
        <>
            <section className="Add_money Withdrawl_Request_Form">
                <div className="row">
                    <div className="col-lg-9 mx-auto">


                        <div className="addmnbox">
                            <h6 className="adh6">Withdrawal Amount</h6>
                            <div className="form-group">
                                <Form.Control
                                    type="number"
                                    placeholder="Enter Amount"
                                    {...register("amount", {
                                        required: "Amount is required",
                                        min: {
                                            value: 10,
                                            message: "Minimum add amount is ₹10",
                                        },
                                        max: {
                                            value: 50000,
                                            message: "Maximum limit is ₹50,000",
                                        },
                                        validate: (value) =>
                                            value > 0 || "Amount must be greater than 0",
                                    })}
                                />
                                {errors.amount && (
                                    <p style={{ color: "red", marginTop: "5px" }}>
                                        {errors.amount.message}
                                    </p>
                                )}

                            </div>

                            <div className="type_div">
                                <h6 className="adh6">Payment mode</h6>
                                <Form.Check
                                    type="radio"
                                    label="Bank Account"
                                    name="payment_method"
                                    defaultChecked={true}
                                    value="bank"
                                    {...register("payment_method", { required: "Select payment mode" })}
                                />

                                <Form.Check
                                    type="radio"
                                    label="UPI"
                                    name="payment_method"
                                    value="upi"
                                    {...register("payment_method", { required: "Select payment mode" })}
                                />

                            </div>
                            {paymentMethod === "bank" && (
                                <>
                                    <h6 className="adh6">Account Number</h6>
                                    <div className="form-group">
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Account Number"
                                            {...register("account_no", {
                                                required: "Account number is required",
                                                pattern: {
                                                    value: /^[0-9]+$/,
                                                    message: "Account number must contain only digits",
                                                },
                                                minLength: {
                                                    value: 9,
                                                    message: "Account number must be at least 9 digits",
                                                },
                                                maxLength: {
                                                    value: 18,
                                                    message: "Account number cannot exceed 18 digits",
                                                },
                                            })}

                                        />
                                        {errors.account_no && (
                                            <p style={{ color: "red", marginTop: "5px" }}>
                                                {errors.account_no.message}
                                            </p>
                                        )}
                                    </div>

                                    <h6 className="adh6">Confirm Account Number</h6>
                                    <div className="form-group">
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Account Number Comfirm"
                                            {...register("c_account_no", {
                                                required: "Account number is required",
                                                pattern: {
                                                    value: /^[0-9]+$/,
                                                    message: "Account number must contain only digits",
                                                },
                                                minLength: {
                                                    value: 9,
                                                    message: "Account number must be at least 9 digits",
                                                },
                                                maxLength: {
                                                    value: 18,
                                                    message: "Account number cannot exceed 18 digits",
                                                },
                                                validate: (value) =>
                                                    value === watch("account_no") || "Account numbers do not match"

                                            })}
                                        />
                                        {errors.c_account_no && (
                                            <p style={{ color: "red", marginTop: "5px" }}>
                                                {errors.c_account_no.message}
                                            </p>
                                        )}
                                    </div>

                                    <h6 className="adh6">IFSC Code</h6>
                                    <div className="form-group">
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter IFSC code"
                                            {...register("ifsc_code", {
                                                required: "IFSC code is required",
                                                pattern: {
                                                    value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                                                    message: "Enter a valid IFSC code",
                                                },
                                                minLength: {
                                                    value: 11,
                                                    message: "IFSC must be exactly 11 characters",
                                                },
                                                maxLength: {
                                                    value: 11,
                                                    message: "IFSC must be exactly 11 characters",
                                                },
                                            })}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                                            }}

                                        />
                                        {errors.ifsc_code && (
                                            <p style={{ color: "red", marginTop: "5px" }}>
                                                {errors.ifsc_code.message}
                                            </p>
                                        )}
                                    </div>

                                    <h6 className="adh6">Account Holder Name</h6>
                                    <div className="form-group">
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Account Holder Name"
                                            {...register("account_holder_name", {
                                                required: paymentMethod === "bank" ? "Account holder name is required" : false,
                                                pattern: {
                                                    value: /^[A-Za-z.\- ]{2,50}$/,
                                                    message:
                                                        "Name should contain only letters, spaces, dot or hyphen (2-50 characters)",
                                                },
                                                minLength: {
                                                    value: 2,
                                                    message: "Name must be at least 2 characters",
                                                },
                                                maxLength: {
                                                    value: 50,
                                                    message: "Name cannot exceed 50 characters",
                                                },
                                            })}
                                        />


                                        {errors.account_holder_name && (
                                            <p className="text-danger">{errors.account_holder_name.message}</p>
                                        )}
                                    </div>
                                </>

                            )}

                            {paymentMethod === "upi" && (
                                <>
                                    <h6 className="adh6">UPI ID</h6>
                                    <div className="form-group">
                                        <Form.Control
                                            type="text"
                                            placeholder="example@upi"
                                            {...register("upi_id", {
                                                required: "UPI ID is required",
                                                pattern: {
                                                    value: /^[\w.-]+@[\w.-]+$/,
                                                    message: "Invalid UPI ID",
                                                },
                                            })}
                                        />

                                        {errors.upi_id && (
                                            <p className="text-danger">{errors.upi_id.message}</p>
                                        )}
                                    </div>
                                    <h6 className="adh6">Account Holder Name</h6>
                                    <div className="form-group">
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Account Holder Name"
                                            {...register("account_holder_name", {
                                                required: paymentMethod === "upi" ? "Account holder name is required" : false,
                                                pattern: {
                                                    value: /^[A-Za-z.\- ]{2,50}$/,
                                                    message:
                                                        "Name should contain only letters, spaces, dot or hyphen (2-50 characters)",
                                                },
                                                minLength: {
                                                    value: 2,
                                                    message: "Name must be at least 2 characters",
                                                },
                                                maxLength: {
                                                    value: 50,
                                                    message: "Name cannot exceed 50 characters",
                                                },
                                            })}
                                        />


                                        {errors.account_holder_name && (
                                            <p className="text-danger">{errors.account_holder_name.message}</p>
                                        )}
                                    </div>



                                </>
                            )}



                            <Pink_Btn
                                btnText={loading ? "Processing..." : "Withdraw"}
                                onClick={handleSubmit(WithdrawMoneyFuntion)}
                            />

                        </div>


                    </div>
                </div>

                <Success_Modal
                    successText="Withdraw request Successfully Sent!"
                    show={showModal}
                    onHide={() => {
                        setShowModal(false);
                    }}
                />
            </section>
        </>
    );
};

export default Withdrawl_Request_Form;
